import { DatePipe, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { CoreModule } from '@app/core/core.module';
import { ContextBannerComponent } from '@app/ui/context-banner/context-banner.component';
import { FooterComponent } from '@app/ui/footer/footer.component';
import { HeaderComponent } from '@app/ui/header/header.component';
import { OrderModule } from '@app/ui/order/order.module';
import { MobileMenuComponent } from './ui/header/mobile-menu/mobile-menu.component';
import { RemainingTimeOrderComponent } from './ui/header/remaining-time-order/remaining-time-order.component';
import { UserComponent } from './ui/header/user/user.component';
import { ScanComponent } from './ui/scan/scan.component';
import { VendorModule } from './vendor/vendor.module';
import { HeaderEmptyComponent } from './ui/header-empty/header-empty.component';
import { PriceListTypeSelectorComponent } from './ui/header/price-list-type-selector/price-list-type-selector.component';
import { DialogComponent } from './core/ui/dialog/dialog.component';
import { DialogFrancoComponent } from './ui/dialog/dialog-franco/dialog-franco.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogOrderCreationComponent } from './ui/dialog/dialog-order-creation/dialog-order-creation.component';
import { ElasticSearchConfigTestComponent } from './ui/elastic-search/elastic-search-config-test/elastic-search-config-test.component';
import { ProductPickerComponent } from './ui/product-picker/product-picker.component';
import { AutocompleteComponent } from "./ui/autocomplete/autocomplete.component";
import { AppConfigurationService } from './core/service/app-configuration.service';
import { MaintenanceComponent } from './ui/maintenance/maintenance.component';
import { TermsOfServiceValidationComponent } from './ui/dashboard/terms-of-service-validation-component/terms-of-service-validation.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeScannerComponent } from './ui/scan/shared-scanner/barcode-scanner.component';
import { WizardMenuComponent } from './ui/wizard-menu/wizard-menu.component';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    ContextBannerComponent,
    WizardMenuComponent,
    HeaderComponent,
    FooterComponent,
    RemainingTimeOrderComponent,
    MobileMenuComponent,
    ScanComponent,
    UserComponent,
    HeaderEmptyComponent,
    PriceListTypeSelectorComponent,
    DialogComponent,
    DialogFrancoComponent,
    DialogOrderCreationComponent,
    ElasticSearchConfigTestComponent,
    ProductPickerComponent,
    MaintenanceComponent,
    TermsOfServiceValidationComponent,
    BarcodeScannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule.forRoot(),
    VendorModule,
    OrderModule,
    AutocompleteComponent
  ],
  exports: [],
  bootstrap: [AppComponent],
  providers: [DatePipe, AppConfigurationService],
})
export class AppModule { }
